export default "__VITE_ASSET__DlbwBfq9__"